import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../../ampli';
import { Icon } from '../../../../components/common/icon/Icon';
import { pageInfo } from '../../../../constants/pageInfo/pageInfo.constant';
import { useLayout } from '../../../../hooks/screen/useLayout';
import { useCheckUserLoggedIn } from '../../../../hooks/user/useCheckUserLoggedIn';

export const OAuthLoginPage = () => {
  const navigate = useNavigate();
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  useLayout({
    fixedHeader: <></>,
    fixedHeaderHeight: 0,
    fixedFooter: <></>,
    fixedFooterHeight: 0,
  });

  const loginWithKakao = () => {
    const { Kakao } = window;
    const { REACT_APP_KAKAO_SCOPE } = process.env;

    Kakao.Auth.authorize({
      redirectUri: `${process.env.REACT_APP_SERVER_URL}/auth/oauth-kakao-callback`,
      scope: REACT_APP_KAKAO_SCOPE,
    });
  };

  useEffect(() => {
    if (isUserLoggedIn) {
      navigate('/home', { replace: true });
    }
  }, [isUserLoggedIn]);

  return (
    <>
      <Helmet>
        <title>{pageInfo.loginPage.title}</title>
      </Helmet>

      <Container>
        <Icon name="CelebratingHand" width={150} height={150} />
        <TextSection>
          <Title>{'플루바 마켓 시작하기'}</Title>
          <Description>{'중고 트랙터 매물 정보는 물론\n농업에 관련된 정보까지!'}</Description>
        </TextSection>

        <ButtonSection>
          <LoginButton
            backgroudColor="#FFD337"
            onClick={() => {
              ampli.마이카카오로그인버튼클릭();
              loginWithKakao();
            }}
          >
            <Icon name="Kakao2" width={24} height={24} />
            <ButtonText>카카오 아이디 로그인</ButtonText>
            <Icon name="AngleRight" fill={'#232429'} width={14} height={14} />
          </LoginButton>

          <LoginButton
            backgroudColor="#F2F2F7"
            onClick={() => {
              ampli.마이애플로그인버튼클릭();
              window.location.href = `${process.env.REACT_APP_SERVER_URL}/auth/oauth-apple`;
            }}
          >
            <Icon name="Apple2" width={24} height={24} />
            <ButtonText>애플 아이디 로그인</ButtonText>
            <Icon name="AngleRight" width={14} height={14} />
          </LoginButton>
        </ButtonSection>
      </Container>
    </>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100vh;

  padding: 24px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 16px;

  margin-bottom: 24px;
`;

const Title = styled.h1`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XX-Large/xxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */
`;

const Description = styled.pre`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);
  text-align: center;

  /* Display/Large/l-light */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 130%; /* 20.8px */
`;

const ButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const LoginButton = styled.button<{ backgroudColor: string }>`
  width: 300px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: var(--radius-large, 16px);

  gap: 10px;

  border-radius: var(--radius-medium, 8px);
  background: ${(props) => props.backgroudColor};
`;

const ButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-medium */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */
`;
